/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class CashRegister {
  baseApi = ENV.BASE_API;

  async openCashRegister(accessToken, openingBalance) {
    try {
      const url = `${this.baseApi}/cash-registers/open`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ openingBalance }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async closeCashRegister(accessToken, closingBalance) {
    try {
      const url = `${this.baseApi}/cash-registers/close`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ closingBalance }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getActiveCashRegister(accessToken) {
    try {
      const url = `${this.baseApi}/cash-registers/active`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getCashRegisters(accessToken, queryParams = {}) {
    try {
      const query = new URLSearchParams(queryParams).toString();
      const url = `${this.baseApi}/cash-registers?${query}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getCashReport(accessToken, startDate, endDate) {
    try {
      const url = `${this.baseApi}/reports/cash?startDate=${startDate}&endDate=${endDate}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getGeneralIncomeReport(accessToken, startDate, endDate) {
    try {
      const url = `${this.baseApi}/reports/general-income?startDate=${startDate}&endDate=${endDate}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
